import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../baseurl";
import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "../component/Header";
import { FaEye, FaEyeSlash } from "react-icons/fa"; 

function SetPassword() {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Passwords do not match",
        toast: true,
        position: "top-end",
        timer: 2500,
        showConfirmButton: false,
        background: "#e74c3c",
        color: "#fff",
      });
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${baseurl}setVendorPassword`, {
        email,
        token,
        password: formData.password,
      });

      Swal.fire({
        icon: "success",
        title: res.data.message || "Password set successfully!",
        toast: true,
        position: "top-end",
        timer: 2500,
        showConfirmButton: false,
        background: "#28a745",
        color: "#fff",
      });

      navigate("/vendor/login");
    } catch (err) {
      console.error("Error:", err.response);
      Swal.fire({
        icon: "error",
        title: err.response?.data?.error || "Something went wrong",
        toast: true,
        position: "top-end",
        timer: 2500,
        showConfirmButton: false,
        background: "#e74c3c",
        color: "#fff",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="setpassword-container">
        <div className="setpassword-card">
          <h3 className="card-title">Set Your Password</h3>
          <p className="card-subtitle">
            Create a strong password to secure your vendor account.
          </p>

          <form onSubmit={handleSubmit}>
            {/* Password Field */}
            <div className="form-group">
              <label>Password</label>
              <div className="input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <span
                  className="icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>

            {/* Confirm Password Field */}
            <div className="form-group">
              <label>Confirm Password</label>
              <div className="input-wrapper">
                <input
                  type={showConfirm ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                />
                <span
                  className="icon"
                  onClick={() => setShowConfirm(!showConfirm)}
                >
                  {showConfirm ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading && <span className="spinner"></span>}
              {loading ? "Setting Password..." : "Set Password"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default SetPassword;
